var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5264 2.13158C17.5264 2.7856 16.9962 3.31579 16.3422 3.31579L6.3948 3.3158C5.74077 3.3158 5.21058 2.78561 5.21058 2.13158C5.21058 1.47756 5.74077 0.947374 6.3948 0.947374L16.3422 0.947373C16.9962 0.947373 17.5264 1.47756 17.5264 2.13158Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31592 2.13158C3.31592 2.78561 2.78573 3.3158 2.13171 3.3158C1.47769 3.3158 0.947497 2.78561 0.947497 2.13159C0.947497 1.47756 1.47769 0.947375 2.13171 0.947375C2.78573 0.947375 3.31592 1.47756 3.31592 2.13158Z",
    fill: "#7583F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5264 6.8684C17.5264 7.52242 16.9962 8.05261 16.3422 8.05261L6.3948 8.05261C5.74077 8.05261 5.21058 7.52242 5.21058 6.8684C5.21058 6.21438 5.74077 5.68419 6.3948 5.68419L16.3422 5.68419C16.9962 5.68419 17.5264 6.21438 17.5264 6.8684Z",
    fill: "#5062F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31592 6.86852C3.31592 7.52254 2.78573 8.05273 2.13171 8.05273C1.47769 8.05273 0.947497 7.52255 0.947497 6.86852C0.947497 6.2145 1.47769 5.68431 2.13171 5.68431C2.78573 5.68431 3.31592 6.2145 3.31592 6.86852Z",
    fill: "#7583F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5264 11.6053C17.5264 12.2594 16.9962 12.7895 16.3422 12.7895L6.3948 12.7896C5.74077 12.7896 5.21058 12.2594 5.21058 11.6053C5.21058 10.9513 5.74077 10.4211 6.3948 10.4211L16.3422 10.4211C16.9962 10.4211 17.5264 10.9513 17.5264 11.6053Z",
    fill: "#5062F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31592 11.6053C3.31592 12.2594 2.78573 12.7896 2.13171 12.7896C1.47769 12.7895 0.947497 12.2594 0.947497 11.6053C0.947497 10.9513 1.47769 10.4211 2.13171 10.4211C2.78573 10.4211 3.31592 10.9513 3.31592 11.6053Z",
    fill: "#7583F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5264 16.3422C17.5264 16.9962 16.9962 17.5264 16.3422 17.5264L6.3948 17.5264C5.74077 17.5264 5.21058 16.9962 5.21058 16.3422C5.21058 15.6881 5.74077 15.1579 6.3948 15.1579L16.3422 15.1579C16.9962 15.1579 17.5264 15.6881 17.5264 16.3422Z",
    fill: "#5062F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31592 16.3422C3.31592 16.9962 2.78573 17.5264 2.13171 17.5264C1.47769 17.5264 0.947497 16.9962 0.947497 16.3422C0.947497 15.6881 1.47769 15.1579 2.13171 15.1579C2.78573 15.1579 3.31592 15.6881 3.31592 16.3422Z",
    fill: "#7583F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBlue);
export default __webpack_public_path__ + "static/media/listBlue.177af119cc2a28c58c4c9c3e114609bb.svg";
export { ForwardRef as ReactComponent };